import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-y",
  "use": "icon-y-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-y\">\n<path d=\"M49.1276 48.904H43.0316V18.472C43.0316 17.512 42.2636 16.744 41.3036 16.744H10.8716V10.648H49.1276V48.904ZM10.8716 20.2H39.5756V48.904H10.8716V20.2ZM50.8556 7.192H9.14363C8.18362 7.192 7.41563 7.96 7.41563 8.92V50.68C7.41563 51.64 8.18362 52.408 9.14363 52.408H50.8556C51.8156 52.408 52.5836 51.64 52.5836 50.68V8.92C52.5836 7.96 51.8156 7.192 50.8556 7.192Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol